export enum SRM_TAB {
  ALL_SRM = 'All SRMs',
  RUNNERS = 'Runners',
  COMBOS = 'Combinations',
}
